var radiansToDegrees = function (radians) { return (radians * 180) / Math.PI; };

export { radiansToDegrees };
